<template>
    <div class="main">
        <div class="header">
            <h1>vuejs-modal</h1>
            <a class="github" href="https://github.com/shaodahong/vuejs-modal" target="_blank"></a>
        </div>
        <div class="contain">
            <button class="btn" @click="show">演示</button>
            <p>
                结果：{{result}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                result: undefined
            }
        },
        methods: {
            show: function () {
                this.result = undefined;
                var _self = this;
                this.$modal.input().then(function (res) {
                    _self.result = res;
                }).catch(function (rej) {
                    _self.result = rej;
                })
            }
        }
    }
</script>

<style lang="scss">
    @import './lib/_index.scss';
</style>


// WEBPACK FOOTER //
// app.vue?26e09168